import { Component, OnInit, ElementRef, ViewChild, Inject } from '@angular/core';
import { ComponentDialog } from 'path-shared/models/component-dialog.model';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { ConfirmationDialogService } from 'path-shared/components/confirmation-dialog/confirmation-dialog.service';
import { AuthorizationService } from 'path-shared/services/authorization/authorization-service';
import { I18n } from '@ngx-translate/i18n-polyfill';
import { ToastrService } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { FormService } from 'path-shared/services/form/form.service';
import { Builder } from 'path-shared/models/builder';
import { MotiuNoNotificacio } from '../../models/motius-notificacio.model';
import { MotiusNoNotificacioService } from '../../services/motius-notificacio.service';


@Component({
  selector: 'app-motius-notificacio-editor',
  templateUrl: './motius-notificacio-editor.component.html',
  styleUrls: ['./motius-notificacio-editor.component.scss']
})
export class MotiusNoNotificacioEditorComponent implements OnInit {

  secure_id: string;
  motiuNoNotificacio: MotiuNoNotificacio;
  dialogData: ComponentDialog;
  closeButtonText: string;

  @ViewChild('mainForm') private mainForm: ElementRef;

  constructor(
    private dialog: MatDialog,
    private confirmationDialogService: ConfirmationDialogService,
    public auth: AuthorizationService,
    private motiusNoNotificacioService: MotiusNoNotificacioService,
    private i18n: I18n,
    private toastr: ToastrService,
    public datepipe: DatePipe,
    public thisDialogRef: MatDialogRef<MotiusNoNotificacioEditorComponent>,
    private formService: FormService,
    @Inject(MAT_DIALOG_DATA) public data: ComponentDialog,
    ) {
      this.motiuNoNotificacio = Builder.newMotiuNoNotificacio();
      this.dialogData = data;
      this.secure_id = this.dialogData.id;
      if (this.dialogData.isReadOnly) {
        this.closeButtonText = this.i18n('Cerrar');
      } else {
        this.closeButtonText = this.i18n('Llista');
      }
   }

  ngOnInit() {
    if (this.secure_id !== null) {
      this.motiusNoNotificacioService.getMotiuNoNotificacio(this.secure_id).subscribe(data => {
        this.motiuNoNotificacio = data;
      });
    }
  }

  save() {
    if (this.formService.allFieldsValid(this.mainForm)) {

      this.motiusNoNotificacioService.setMotiuNoNotificacio(this.motiuNoNotificacio).subscribe(result => {
        this.toastr.info(this.i18n('Motivo de no notificación guardado correctamente'));
        this.thisDialogRef.close(true);
      });
    } else {
      this.toastr.warning(this.i18n('Hay errores en el formulario!'));
      if (!this.mainForm.nativeElement.classList.contains('displayErrors')) {
        this.mainForm.nativeElement.classList.add('displayErrors');
      }
    }
  }

  cancel() {
    this.thisDialogRef.close(false);
  }

  remove() {
    this.confirmationDialogService.confirm(this.i18n('Confirme'), this.i18n('¿Seguro que desea eliminar el motivo de no notificación?'))
    .then((confirmed) => {
        if (confirmed) {
          this.motiusNoNotificacioService.removeMotiuNoNotificacio(this.secure_id).subscribe(result => {
            this.toastr.success(this.i18n('Motivo de no notificación eliminado correctament'));
            this.dialog.closeAll();
            this.thisDialogRef.close(true);
          });
        }
      });
  }

}
